import { render } from "./PopupVideo.vue?vue&type=template&id=3427066a&scoped=true"
import script from "./PopupVideo.vue?vue&type=script&lang=js"
export * from "./PopupVideo.vue?vue&type=script&lang=js"

import "@css/popup.css?vue&type=style&index=0&id=3427066a&scoped=true&lang=css"
import "./PopupVideo.vue?vue&type=style&index=1&id=3427066a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3427066a"]])

export default __exports__